
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/um/fyrirtaekid/hafa-samband",
      function () {
        return require("private-next-pages/um/fyrirtaekid/hafa-samband.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/um/fyrirtaekid/hafa-samband"])
      });
    }
  